import React from 'react';
import { spacing, borderRadius, shadows, colors } from './tokens';
import { typography } from './tokens';

/**
 * AdminCard
 * 
 * Standardized card component for admin pages.
 * 
 * @param {string} title - Optional card title
 * @param {ReactNode} children - Card content
 * @param {ReactNode} actions - Optional actions to display in header
 * @param {string} density - Card density: 'comfortable' | 'compact' (default: 'comfortable')
 * @param {object} style - Additional styles
 * @param {function} onClick - Click handler
 * @param {function} onKeyDown - Key down handler
 * @param {string} role - ARIA role
 * @param {number} tabIndex - Tab index
 */
export default function AdminCard({ 
  title, 
  children, 
  actions, 
  density = 'comfortable',
  className = '',
  style, 
  onClick, 
  onKeyDown, 
  role, 
  tabIndex,
  ...rest 
}) {
  const densityClass = density === 'compact' ? 'admin-card-compact' : '';
  const classes = `admin-card ${densityClass} ${className}`.trim();
  
  return (
    <div 
      className={classes}
      style={style}
      onClick={onClick}
      onKeyDown={onKeyDown}
      role={role}
      tabIndex={tabIndex}
      {...rest}
    >
      {(title || actions) && (
        <div className="admin-card-header">
          {title && <h2 className="admin-card-title">{title}</h2>}
          {actions && <div className="admin-card-actions">{actions}</div>}
        </div>
      )}
      <div className="admin-card-content">
        {children}
      </div>
    </div>
  );
}

// Styles removed - now using CSS classes from admin-ui.css

